/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrentUserPylonUnreadBaseline200Response
 */
export interface UpdateCurrentUserPylonUnreadBaseline200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCurrentUserPylonUnreadBaseline200Response
     */
    success?: boolean;
}

/**
 * Check if a given object implements the UpdateCurrentUserPylonUnreadBaseline200Response interface.
 */
export function instanceOfUpdateCurrentUserPylonUnreadBaseline200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateCurrentUserPylonUnreadBaseline200ResponseFromJSON(json: any): UpdateCurrentUserPylonUnreadBaseline200Response {
    return UpdateCurrentUserPylonUnreadBaseline200ResponseFromJSONTyped(json, false);
}

export function UpdateCurrentUserPylonUnreadBaseline200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrentUserPylonUnreadBaseline200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function UpdateCurrentUserPylonUnreadBaseline200ResponseToJSON(value?: UpdateCurrentUserPylonUnreadBaseline200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

